import { Transformer } from "../../../../Transformer/index.js";
import Api from "../../../../Api/SystemLogApi";

export class SystemLogService {
  constructor() {
    this.transformer = new Transformer();
    this.Api = new Api();
  }
  async grid(args) {
    return await this.transformer.getGrid(this.Api, "getSystemLogs", args);
  }
  async getPanel(id) {
    return await this.transformer.getGridPanel(this.Api, "getSystemLog", null, id);
  }
  async get(id) {
    return await this.transformer.getItem(this.Api, "getSystemLog", id);
  }
}
